import React from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.3.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "react-toastify/dist/ReactToastify.css";

import AdminLayout from "layouts/Admin";
import AuthLayout from "layouts/Auth";

import { history } from "utils";
import Landing from "views/landing";
import AboutUs from "views/about/aboutUs";
import ScheduleDemoPage from "views/schesule-a-demo";
import CreatorsList from "views/listings";
import { NftListOfCreator } from "views/listings/nftListOfCreator";
import Wall from "views/Wall";
import Pricings from "views/pricing";
// import { NftDetailsPublic } from "views/listings/nftDetailsPublic";

const Main = () => {
    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Router history={history}>
                <Switch>
                    <Route path="/app" render={(props) => <AdminLayout {...props} />} />
                    <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
                    <Route path="/about-us" render={(props) => <AboutUs {...props} />} />
                    <Route path="/schedule" render={(props) => <ScheduleDemoPage {...props} />} />
                    <Route path="/organisations" render={(props) => <CreatorsList {...props} />} />
                    <Route path="/wall" render={(props) => <Wall {...props} />} />
                    <Route path="/pricing" render={(props) => <Pricings {...props} />} />
                    <Route path="/organisation/:username" render={(props) => <NftListOfCreator {...props} />} />
                    {/* <Route path="/certificate/:nftId" render={(props) => <NftDetailsPublic {...props} />} /> */}
                    <Route path="/" render={(props) => <Landing {...props} />} />
                    <Redirect to="/auth/signin" />
                </Switch>
            </Router>
        </>
    );
};

export default Main;
